import { Skeleton, Stack } from '@mui/material';

export const PieChartSkeleton = () => {
  return (
    <Stack direction="row">
      <Skeleton variant="circular" sx={{ width: '11.875rem', height: '11.875rem', mx: 2, my: 4 }} />
      <Stack direction="column" flex={1}>
        <Stack direction="row" gap={1}>
          <Skeleton variant="text" sx={{ flex: 2, height: '2rem' }} />
          <Skeleton variant="text" sx={{ flex: 2, height: '2rem' }} />
          <Skeleton variant="text" sx={{ flex: 1, height: '2rem' }} />
        </Stack>
        {Array.from(Array(4)).map((_v, index) => (
          <Stack key={index} direction="row" gap={1}>
            <Skeleton variant="text" sx={{ flex: 2, height: '3.5rem' }} />
            <Skeleton variant="text" sx={{ flex: 2, height: '3.5rem' }} />
            <Skeleton variant="text" sx={{ flex: 1, height: '3.5rem' }} />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
